<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1a" id="halftitle"><a id="page_1"></a>F<span class="small">OR</span> N<span class="small">OBODY</span>’<span class="small">S</span> E<span class="small">YES</span> O<span class="small">NLY</span></h1>
<p class="noindent"><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?c868d0b0